import { z } from 'zod';

export const Country = z.object({
  id: z.string().default(''),
  name: z.string().default(''),
  isdCode: z.string().nullable().default(''),
  enabled: z.boolean().default(true),
  createdAt: z.string().default(''),
  updatedAt: z.string().default(''),
});
export type CountryType = z.infer<typeof Country>;
